export default {
  onExit: {
    name: 'nsCloseContent',
    context: 'click',
    additionalProperties: {}
  }
};
